import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import type { PropType } from 'vue';
  import { onUnmounted } from "vue";
  import { useScript } from "@unhead/vue"
  import { OrderNewCardRef } from "@/api/orders";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NewCardForm',
  props: {
    newCardRequest: { required: true, type: Object as PropType<OrderNewCardRef> }
  },
  setup(__props) {

const props = __props;

  
  const { $script } = useScript(
    { key: 'peach-script', src: process.env.VUE_APP_PEACH_ENDPOINT.replace("{{checkoutId}}", props.newCardRequest.checkoutId) }
  )

  const redirectRoute = `${window.location.origin}/card-update/${props.newCardRequest.orderId}/${props.newCardRequest.checkoutId}`;

  onUnmounted(() => {
    $script.remove();
  })

return (_ctx: any,_cache: any) => {
  return (__props.newCardRequest.checkoutId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          action: redirectRoute,
          class: "paymentWidgets",
          "data-brands": "VISA MASTER AMEX"
        })
      ]))
    : _createCommentVNode("", true)
}
}

})